"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _reactIntl = require("react-intl");

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require("../../../packages/common-utilities/src/string_utility");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _click_or_escape_outside = require("./click_or_escape_outside");

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _dropdown_component = require("./global_components/dropdown_component");

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _ramda = require("ramda");

var _table_component = require("./global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _collection_utility = require("../../../packages/common-utilities/src/collection_utility");

var _number_utility = require("../../../packages/common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var PerformanceScenariosCard = function (_React$PureComponent) {
  _inherits(PerformanceScenariosCard, _React$PureComponent);

  function PerformanceScenariosCard(props) {
    _classCallCheck(this, PerformanceScenariosCard);

    var _this = _possibleConstructorReturn(this, (PerformanceScenariosCard.__proto__ || Object.getPrototypeOf(PerformanceScenariosCard)).call(this, props));

    _this.renderDateRangeComponent = _this.renderDateRangeComponent.bind(_this);
    _this.renderSingleDateOption = _this.renderSingleDateOption.bind(_this);
    _this.setDateFilter = _this.setDateFilter.bind(_this);

    _this.state = {
      selectedDate: _collection_utility.CollectionUtility.size(_this.props.historicalData.historicalPerformanceScenarios) ? _this.props.historicalData.historicalPerformanceScenarios[_this.props.historicalData.historicalPerformanceScenarios.length - 1].performanceReturnEffectiveDate : null
    };
    return _this;
  }

  _createClass(PerformanceScenariosCard, [{
    key: "setDateFilter",
    value: function setDateFilter(event) {
      var target = (0, _ramda.isNil)(event.target.getAttribute('data-option-value')) ? event.target.parentNode : event.target;
      this.setState({
        selectedDate: target.getAttribute("data-option-value")
      });
    }
  }, {
    key: "dateFilterOptions",
    value: function dateFilterOptions() {
      var _this2 = this;

      var dates = [];
      var dateOptions = [];

      mapIndexed(function (item) {
        var dateOption = _date_formatter2.default.getDateInSpecificFormat(item.performanceReturnEffectiveDate, 'MMMM YYYY');
        if (!dateOptions.includes(dateOption)) {
          dates.push(_this2.renderSingleDateOption(item, dateOption));
          dateOptions.push(dateOption);
        }
      }, this.props.historicalData.historicalPerformanceScenarios);

      return dates;
    }
  }, {
    key: "renderSingleDateOption",
    value: function renderSingleDateOption(period, dateOption) {
      return _react2.default.createElement(
        "div",
        { "data-option-value": period.performanceReturnEffectiveDate, "data-display-value": dateOption, onClick: this.setDateFilter, className: "dropdown-list-item", role: "option" },
        _react2.default.createElement(
          "span",
          { className: "font-light caption", "data-display-value": dateOption,
            "data-option-value": period.performanceReturnEffectiveDate },
          dateOption
        )
      );
    }
  }, {
    key: "renderDateRangeComponent",
    value: function renderDateRangeComponent() {
      var selectDateValue = this.state.selectedDate;
      if (selectDateValue == null) {
        selectDateValue = this.props.historicalData.historicalPerformanceScenarios[this.props.historicalData.historicalPerformanceScenarios.length - 1].performanceReturnEffectiveDate;
      }
      selectDateValue = _date_formatter2.default.getDateInSpecificFormat(selectDateValue, 'MMMM YYYY');

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row margin-top-20 padding-horizontal-10" },
          _react2.default.createElement(
            "div",
            { className: "filter col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xlg-3 font-regular caption", role: "label",
              id: "DateRange" },
            _string_utility2.default.renderFormattedLabel("DATE RANGE", "pdp-performance-scenarios-date-range-label")
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row margin-top-10  padding-horizontal-20" },
          _react2.default.createElement(
            "div",
            { className: "" },
            _react2.default.createElement(
              _click_or_escape_outside2.default,
              { id: "performance-scenario-effective-date-selector" },
              _react2.default.createElement(_dropdown_component2.default, {
                dropdownContent: this.dateFilterOptions(),
                id: "performanceScenariosDateFilter",
                className: (this.props.breakpoint < 4 ? "width-percent-100" : "width-percent-25") + " border-pinkish-grey category height-45 ",
                breakpoint: this.props.breakpoint,
                initialActiveSelect: selectDateValue,
                alwaysOpenOnSelect: false,
                ariaLabelledby: "DateRange"
              })
            )
          )
        )
      );
    }
  }, {
    key: "renderRecommendedHoldingPeriodBanner",
    value: function renderRecommendedHoldingPeriodBanner() {
      var investmentValue = '-';

      if (_collection_utility.CollectionUtility.size(this.props.shareclass.fundShareclassHypoPerformances) > 0) {
        investmentValue = this.props.shareclass.fundShareclassHypoPerformances[0].cashDefault;
      }

      return _react2.default.createElement(
        "div",
        {
          className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 background-soft-grey padding-vertical-10 margin-top-10" },
        _react2.default.createElement(
          "div",
          { className: "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xlg-4 print-full-width padding-all-0", "data-testid": "performance-scenarios-recommended-holding-period" },
          _react2.default.createElement(
            "span",
            {
              className: "body-bold" },
            _string_utility2.default.renderFormattedLabel("Recommended Holding Period: ", "pdp-performance-scenarios-recommended-holding-period-label")
          ),
          this.getRecommendedHoldingPeriodLabel()
        ),
        _react2.default.createElement(
          "div",
          { className: "col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xlg-8 print-full-width padding-all-0", "data-testid": "performance-scenarios-investment-amount" },
          _react2.default.createElement(
            "span",
            {
              className: "body-bold" },
            _string_utility2.default.renderFormattedLabel("Investment: ", "pdp-performance-scenarios-investment-label")
          ),
          this.props.shareclass.currencyCode,
          " ",
          _number_utility2.default.convertToEuropeanFormat(_number_utility2.default.convertToNumberWithCommas(investmentValue))
        )
      );
    }
  }, {
    key: "getRecommendedHoldingPeriodLabel",
    value: function getRecommendedHoldingPeriodLabel() {
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.priipsHoldingPeriod)) {
        var priipsHoldingPeriod = Number(this.props.priipsHoldingPeriod);
        if (priipsHoldingPeriod > 1) {
          return priipsHoldingPeriod + ' years';
        } else if (priipsHoldingPeriod === 1) {
          return '1 year';
        }
      }

      return '-';
    }
  }, {
    key: "renderHeaderRow",
    value: function renderHeaderRow() {
      var row = [];

      row.push(_react2.default.createElement("td", { key: "Inital", "data-testid": "performance-scenarios-table-header", className: "tag white-space-nowrap" }));
      row.push(_react2.default.createElement(
        "td",
        { key: "1yr", "data-testid": "performance-scenarios-table-header-1yr",
          className: "body-bold white-space-nowrap text-right" },
        _string_utility2.default.renderFormattedLabel("If you exit after 1 year", "pdp-performance-scenarios-after-1-year"),
        this.props.priipsHoldingPeriod === "1" && _react2.default.createElement(
          "div",
          { className: "disclaimer2" },
          _string_utility2.default.renderFormattedLabel("(Recommended holding period)", "pdp-performance-scenarios-recommended-holding-period")
        )
      ));
      if (this.props.priipsHoldingPeriod === "3" || this.props.priipsHoldingPeriod === "5") {
        row.push(_react2.default.createElement(
          "td",
          { key: "other-yr", "data-testid": "performance-scenarios-table-header-other-yr",
            className: "body-bold white-space-nowrap text-right" },
          _string_utility2.default.renderFormattedLabel("If you exit after certain years", "pdp-performance-scenarios-exit-after-certain-years", { certain: this.props.priipsHoldingPeriod }),
          _react2.default.createElement(
            "div",
            { className: "disclaimer2" },
            _string_utility2.default.renderFormattedLabel("(Recommended holding period)", "pdp-performance-scenarios-recommended-holding-period")
          )
        ));
      }

      return row;
    }
  }, {
    key: "renderDataRows",
    value: function renderDataRows() {
      var _this3 = this;

      var rows = [];
      var filterData = this.props.historicalData.historicalPerformanceScenarios ? this.props.historicalData.historicalPerformanceScenarios.filter(function (item) {
        return item.performanceReturnEffectiveDate === _this3.state.selectedDate;
      }) : [];

      this.renderTableData(1, filterData, rows);
      this.renderTableData(2, filterData, rows);
      this.renderTableData(3, filterData, rows);
      this.renderTableData(4, filterData, rows);

      return rows;
    }
  }, {
    key: "renderTableData",
    value: function renderTableData(fundShareclassHypoReturnType, performanceScenarioList, rows) {
      var filteredPerformance = performanceScenarioList.filter(function (item) {
        return item.fundShareclassHypoReturnType === fundShareclassHypoReturnType;
      });
      if (_collection_utility.CollectionUtility.size(filteredPerformance) > 0) {
        var performanceScenarioData = filteredPerformance[0];
        rows.push(_react2.default.createElement(
          "tr",
          { className: "padding-vertical-5 category row-divider" },
          _react2.default.createElement(
            "td",
            { className: "body-bold margin-top-5 print-font-size-13 text-left",
              "data-testid": 'performance-scenarios-table-data' },
            _string_utility2.default.getLocalizedString(this.props.intl, "Scenario", "pdp-performance-scenarios-row-header", { fundShareclassHypoReturnType: fundShareclassHypoReturnType })
          )
        ));
        rows.push(_react2.default.createElement(
          "tr",
          { className: "padding-vertical-5 category row-divider" },
          _react2.default.createElement(
            "td",
            { className: "padding-left-10 margin-top-5 print-font-size-13 text-left", style: { "padding-left": "30px" },
              "data-testid": 'performance-scenarios-table-data' },
            _string_utility2.default.getLocalizedString(this.props.intl, "What you might get back after costs", "pdp-performance-scenarios-after-costs")
          ),
          _react2.default.createElement(
            "td",
            { className: "margin-top-5 print-font-size-13 text-right",
              "data-testid": 'performance-scenarios-table-data-1yr' },
            _number_utility2.default.convertToEuropeanFormat(_number_utility2.default.convertToNumberWithCommas(Math.round(performanceScenarioData.returnAfterCost / 10) * 10, 0)),
            " ",
            this.props.shareclass.currencyCode
          ),
          (this.props.priipsHoldingPeriod === "3" || this.props.priipsHoldingPeriod === "5") && _react2.default.createElement(
            "td",
            { className: "margin-top-5 print-font-size-13 text-right",
              "data-testid": 'performance-scenarios-table-data-holding-period' },
            _number_utility2.default.convertToEuropeanFormat(_number_utility2.default.convertToNumberWithCommas(Math.round(performanceScenarioData.holdingPeriodReturnAfterCost / 10) * 10, 0)),
            " ",
            this.props.shareclass.currencyCode
          )
        ));
        rows.push(_react2.default.createElement(
          "tr",
          { className: "padding-vertical-5 category row-divider" },
          _react2.default.createElement(
            "td",
            { className: "margin-top-5 print-font-size-13 text-left", style: { "padding-left": "30px" },
              "data-testid": 'performance-scenarios-table-data' },
            _string_utility2.default.getLocalizedString(this.props.intl, "Average return each year", "pdp-performance-scenarios-average-return")
          ),
          _react2.default.createElement(
            "td",
            { className: "margin-top-5 print-font-size-13 text-right",
              "data-testid": 'performance-scenarios-table-data-1yr' },
            _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(performanceScenarioData.averageReturnEachYear, '-', 1)
          ),
          (this.props.priipsHoldingPeriod === "3" || this.props.priipsHoldingPeriod === "5") && _react2.default.createElement(
            "td",
            { className: "margin-top-5 print-font-size-13 text-right",
              "data-testid": 'performance-scenarios-table-data-holding-period' },
            _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(performanceScenarioData.holdingPeriodAverageReturnEachYear, '-', 1)
          )
        ));
      }
    }
  }, {
    key: "renderPerformanceScenariosTable",
    value: function renderPerformanceScenariosTable() {
      return _react2.default.createElement(
        "div",
        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 padding-top-10 padding-horizontal-10" },
        _react2.default.createElement(_table_component2.default, {
          tableHeaders: this.renderHeaderRow(),
          tableRows: this.renderDataRows(),
          tableBodyTest: "performance-scenarios-body"
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var effectiveDate = this.state.selectedDate;
      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: "performance-scenarios-card",
          className: "print-full-width",
          headerTitle: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "pdp-performance-scenarios-card-label",
            defaultMessage: "Performance scenarios" }),
          headerTitleId: "performance-scenarios-header",
          headerTitleLabel: "",
          headerLabel: _react2.default.createElement(
            "div",
            { "data-testid": "performnace-scenarios-effective-date",
              className: "margin-top--25 " + (this.props.breakpoint < 3 ? "display-inline padding-horizontal-16" : "float-right text-right") + " disclaimer2" },
            " ",
            _string_utility2.default.getLocalizedString(this.props.intl, "As of", "label-for-as-of-morning-star"),
            " ",
            _date_formatter2.default.getDateInSlashFormatOrNA(effectiveDate)
          ),

          displayStyle: 'width-percent-100',
          breakpoint: this.props.breakpoint,
          disclosureText: this.props.disclosure
        },
        this.renderDateRangeComponent(),
        this.renderRecommendedHoldingPeriodBanner(),
        this.renderPerformanceScenariosTable()
      );
    }
  }]);

  return PerformanceScenariosCard;
}(_react2.default.PureComponent);

exports.default = PerformanceScenariosCard;